var map = {
	"./2017.png": "7436",
	"./2018.png": "7728",
	"./2019.png": "aab6",
	"./2020.png": "a8bb",
	"./ACADEMIA.png": "15cf",
	"./ARVORE.png": "bf42",
	"./BURACO.png": "0f93",
	"./CASCALHO.png": "17c9",
	"./EDUCACAO.png": "af06",
	"./ILUMINACAO.png": "ea48",
	"./LIMPEZA.png": "9436",
	"./OUTROS.png": "aa5e",
	"./SAUDE.png": "35d5",
	"./SEGURANCA.png": "a720",
	"./TRANSITO.png": "c06f",
	"./TRANSPORTE.png": "fcf6",
	"./form.png": "8c37",
	"./timeline.png": "7830"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15b6";